import { Pagination } from "antd";
import React from "react";
import styled from "styled-components";

import { COLORS } from "../../constants";

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledPagination = styled(Pagination)`
  .ant-pagination-item,
  .ant-pagination-prev,
  .ant-pagination-next {
    margin: 0;
    min-width: 30px;
  }

  .ant-pagination-item-active a {
    color: ${COLORS.coeblue4};
  }

  .ant-pagination-item:hover,
  .ant-pagination-item a:hover {
    color: ${COLORS.coeblue4};
  }

  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border: 1px solid ${COLORS.coeblue4};
    color: ${COLORS.coeblue4};
  }

  .ant-pagination-item,
  button.ant-pagination-item-link {
    border: 1px solid transparent;
  }

  .ant-pagination-disabled {
    pointer-events: none;
  }
`;

const TextSecondary = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.black45};
`;

const TableFooter = styled.div`
  display: flex;
`;

const TableFooterContent = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
`;

type Props = {
  page: number;
  pageSize: number;
  data: Array<Array<string | number | boolean | undefined>>;
  totalRowCount: number;
  onPageChange: (page: number) => void;
};

export const AdminTableFooter: React.FC<Props> = ({
  page,
  pageSize,
  totalRowCount,
  data,
  onPageChange,
}) => {
  if (totalRowCount === 0) {
    return null;
  }

  return (
    <TableFooter>
      <TableFooterContent>
        {totalRowCount === undefined ? null : (
          <TextSecondary style={{ whiteSpace: "nowrap" }}>
            Showing {page * pageSize + 1} - {page * pageSize + data.length} of {totalRowCount}
          </TextSecondary>
        )}

        <PaginationContainer>
          {totalRowCount <= pageSize ? null : (
            <StyledPagination
              current={page + 1}
              onChange={page => onPageChange(page - 1)}
              showQuickJumper={false}
              showSizeChanger={false}
              defaultPageSize={pageSize}
              total={totalRowCount}
            />
          )}
        </PaginationContainer>
      </TableFooterContent>
    </TableFooter>
  );
};
